import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Font } from '../../../enum/font';
import { ColorFormat } from '../colorpicker/colorpicker.component';

@Component({
  selector: 'fontpicker',
  templateUrl: './fontpicker.component.html',
  styleUrls: ['./fontpicker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FontpickerComponent),
    multi: true,
  }],
})
export class FontpickerComponent extends BaseInputComponent implements OnInit {

  @Input() fontList = Font;

  selectedFont?: { value: string, name: string };
  isOpen: boolean = false;

  options: any[];
  private fonts: any[];

  toggle(event: Event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
  }

  close() {
    this.isOpen = false;
  }

  onSelect(font) {
    this.selectedFont = font;
    this.form.controls[this.formControlName].setValue(font.value);
    console.log(this.fonts);
    this.close();
  }

  onChange() {
    if (!this.innerValue) {
      this.selectedFont = null;
    } else {
      this.selectedFont = this.fonts.find(f => {
        return f.value === this.innerValue;
      });
    }
    this.resetOptions();
    super.onChange({ target: { value: this.selectedFont } });
  }

  resetOptions() {
    this.options = this.fonts.filter(font => font !== this.selectedFont);
  }

  ngOnInit(): void {
    this.fonts = Object.keys(this.fontList).map((fontKey: string) => {
      return {
        value: this.fontList[fontKey],
        label: fontKey,
      };
    });
    this.form.controls[this.formControlName].valueChanges.subscribe(() => this.onChange());
    this.resetOptions();
    super.ngOnInit();
  }
}
